const config = {
  getApiUrl: () => 'http://app.tickmark-software.local:8000',
};

export default config;
